import React from 'react';
import {FormattedMessage} from 'react-intl';
import {config} from '../../config/config';
const cdn = config.get('baseUrls').cdn;

export function FacebookButton({target}) {
  return (
    <a href={target}>
      <img src={`${cdn}cocobox/img/login2/facebook-circle.png`} alt="Logga in med Facebook	" draggable="false" />
      <br />
      <FormattedMessage id="loginsite.facebook" tagName="span" />
    </a>
  );
}
